import type { FC } from 'react';

import type { NormalizedGallery } from '../useExpandedViewContent';
import { GALLERY_COMPONENT_MAP } from '../useExpandedViewContent';

interface PrototypeGallerySectionProps {
  galleries: NormalizedGallery[];
}

const PrototypeGallerySection: FC<PrototypeGallerySectionProps> = ({ galleries }) => (
  <section className="font-montreal text-zinc-800 dark:text-white/80">
    <div className="mx-auto w-full max-w-[96rem] px-6 sm:px-10 lg:px-16">
      <header className="pb-8">
        <h3 className="text-3xl font-light tracking-tight text-zinc-900 md:text-[2.5rem] dark:text-white">
          Gallery prototypes
        </h3>
      </header>
    </div>

    <div className="mx-auto max-w-[min(96rem,92vw)] space-y-16 px-6 sm:px-10 md:px-16">
      {galleries.map((gallery, index) => {
        const GalleryComponent = GALLERY_COMPONENT_MAP[gallery.layout];

        return <GalleryComponent key={`${gallery.layout}-${index}`} images={gallery.images} />;
      })}
    </div>
  </section>
);

export default PrototypeGallerySection;
